// extracted by mini-css-extract-plugin
export default {"root":"NotificationsPage_root__1i6kD","header":"NotificationsPage_header__75TWV","calendarWrapper":"NotificationsPage_calendarWrapper__aNj80"};